<template src="./template.html"></template>
<style src="./who-is-who.scss" lang="scss"></style>

<script>
  import { mapState, mapActions } from 'vuex'
  import UserOverview from '@/components/modules/user/UserOverview'

  export default {
    name: 'WhoIsWhoPage',
    components: {
      UserOverview,
    },
    metaInfo() {
      return {
        title: this.$t('meta.who-is-who.title'),
      }
    },
    computed: {
      ...mapState('users', [
        'users',
        'pagination',
        'filters',
        'searchedUsers',
      ]),
      options() {
        const options = {
          results: {
            users: this.type === 'extendedSearch' ? this.searchedUsers.results : this.users,
          },
          options: {
            filters: this.type === 'extendedSearch' ? {} : this.filters,
            pagination: this.type === 'extendedSearch' ? this.searchedUsers.pagination : this.pagination,
          },
        }
        return options
      },
      query() {
        return this.$route.query.q || ''
      },
      type() {
        return this.$route.query.type || 'page'
      },
      field_id() {
        return this.$route.query.field_id || ''
      },
    },
    watch: {
      query() {
        this.requestSearchData()
      },
      field_id() {
        this.requestSearchData()
      },
    },
    created() {
      this.requestSearchData()
      this.getUsersListOptions()
    },
    destroyed() {
      this.resetUserIdentifiers()
    },
    methods: {
      ...mapActions('users', [
        'getUsersListOptions',
        'resetUserIdentifiers',
        'getUsersBasedOnSuggestions',
      ]),
      requestSearchData() {
        if (this.type === 'extendedSearch') {
          const payload = {
            field_id: this.field_id,
            query: this.query,
          }
          this.getUsersBasedOnSuggestions(payload)
        }
      },
    },
  }
</script>
